import { Button, Modal } from '@watersport/ui-react-next'
import React from 'react'

import { useLayout } from 'contexts/LayoutProvider'

export interface ConfirmModalProps {
  show: boolean
  onClose: () => void
  onConfirm: (status: boolean) => void
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ show, onClose, onConfirm }) => {
  const { activeRefs } = useLayout()

  return (
    <Modal
      show={show}
      title={'Delete area?'}
      onClose={onClose}
      activeRefs={activeRefs}
      data-testid="confirm-modal"
    >
      <div className="p-5" data-testid="confirm-modal-content">
        <div className="flex items-center justify-start gap-5" data-testid="confirm-modal-buttons">
          <Button
            variant={'outline'}
            text={'No'}
            rounded
            size={'xl'}
            onClick={onClose}
            data-testid="no-button"
          />
          <Button
            variant={'default'}
            text={'Yes, delete'}
            rounded
            size={'xl'}
            onClick={() => onConfirm(true)}
            data-testid="yes-button"
          />
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmModal
